import { carsData } from "../../mock-data/car-data";
import { app_configs } from "../configs";

const { serverUrl, fileServer } = app_configs;
const  origin  = `${serverUrl}/cars`;

/** register new car */
export const addNewCar = (carData, token) => {
    return fetch(`${origin}/register`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors",
        body: JSON.stringify(carData)
    })
}

/**save car images to file server */
export const uploadCarImage = (imageData) => {
    const fileData = new FormData();
    fileData.append("image", imageData);
    return fetch(`${fileServer}/upload_image`, {
        method: "POST",
        headers: {
            "Accept": "application/json",
        },
        body: fileData
    })
}

/**delete car from server */
export const deleteCarImage = (imageUri) => {
    return fetch(`${fileServer}/delete_image`, {
        method: "DELETE",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ uri: imageUri })
    })
}

/** update car Data */
export const updateCarData = (carsData, id, token) => {
    return fetch(`${origin}/update/${id}`, {
        method: "PATCH",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(carsData)
    })
}

/** get some cars **/
export const getSomeCars = (page) => {
    return fetch(`${origin}/bybatch?page=${page}`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        },
        mode: "cors"
    })
}

/** get car data */
export const getCarData = (id) => {
    return fetch(`${origin}/find/${id}`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        },
        mode: "cors"
    })
}

/** delete car data */
export const deleteCarData = (id, token) => {
    //console.log({id, token});
    return fetch(`${origin}/delete/${id}`, {
        method: "DELETE",
        headers: {
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
        mode: "cors"
    })
}


export const processOrder = (orderData) => {
    return fetch(`${origin}/order`,{
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(orderData),
        mode: "cors"
    })
}